import React, { memo } from 'react';

import { Icon, Popover, Text, Spacer } from '@Sage/hoi-poi-ui';
import { getSalesOrderLineUomDisplayLabel, isSalesOrderLineUomInactive } from '@Sage/ssm-utils';

import { getLiteral } from 'utils/getLiteral';

import './UnitOfMeasureReadCell.scss';

const UnitOfMeasureReadCell = memo((params) => {
    const data = params?.data;
    const label = getSalesOrderLineUomDisplayLabel(data);
    const inactive = isSalesOrderLineUomInactive(data);

    const innerClassName = `fm-uom-read-cell${inactive ? ' fm-uom-read-cell--inactive' : ''}${!label ? ' fm-uom-read-cell--empty' : ''}`;

    return (
        <div className="w5-cell w5-cell--align-right" style={{ width: '100%', height: '100%' }}>
            {!label ? (
                <span className={innerClassName} />
            ) : (
                <span className={innerClassName} title={inactive ? undefined : label}>
                    <span className="fm-uom-read-cell__label">{label}</span>
                    {inactive && (
                        <Popover
                            content={
                                <div>
                                    <Text type="subtitle" bold>
                                        {getLiteral('label_warning_inactive_unit_measure')}
                                    </Text>
                                    <Spacer y={2} />
                                    <Text>
                                        {getLiteral('label_warning_inactive_unit_measure_desc')}
                                    </Text>
                                </div>
                            }
                            placement="top"
                            trigger={['hover']}
                        >
                            <span className="fm-uom-read-cell__warning">
                                <Icon name="warningOutline" />
                            </span>
                        </Popover>
                    )}
                </span>
            )}
        </div>
    );
});

UnitOfMeasureReadCell.displayName = 'UnitOfMeasureReadCell';

export default UnitOfMeasureReadCell;
